import {CKEditor} from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import {uploadFile, fileSrc} from './fileUtils'

// Custom upload adapter for CKEditor to upload images to S3
class S3UploadAdapter {
  constructor(loader) {
    this.loader = loader
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise(async (resolve, reject) => {
          try {
            // Upload file to S3
            const fileName = await uploadFile(file, 'editor-images')

            // Return the URL of the uploaded image
            const imageUrl = fileSrc(fileName)

            resolve({
              default: imageUrl,
            })
          } catch (error) {
            reject(error)
          }
        })
    )
  }

  abort() {
    // Reject promise returned from upload() method
  }
}

// Function to create upload adapter
function S3UploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new S3UploadAdapter(loader)
  }
}

export const Editor = ({field, form, ...props}) => {
  return (
    <CKEditor
      editor={ClassicEditor}
      config={{
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'bulletedList',
          'numberedList',
          'blockQuote',
          '|',
          'imageUpload',
          'insertTable',
          'tableColumn',
          'tableRow',
          'mergeTableCells',
          '|',
          'undo',
          'redo',
        ],
        extraPlugins: [S3UploadAdapterPlugin],
      }}
      data={field.value}
      onChange={(event, editor) => {
        const data = editor.getData()
        form.setFieldValue(field.name, data)
      }}
    />
  )
}
